import {WidgetsPresenter} from "@/utils/presenters/interfaces.ts";
import MoreMenuItem from "@/utils/UIConstants/MoreMenuItem.ts";
import Translator from "@/utils/common/Translator.ts";
import NamaCommon from "@/utils/common/NamaCommon.ts";
import NamaURLS from "@/utils/constants/NamaURLS.ts";
import DomainBaseEntities from "@/utils/constants/DomainBaseEntities.ts";
import ListPresenter from "@/utils/common/ListPresenter.ts";
import ObjectChecker from "@/utils/common/ObjectChecker.ts";
import {EditPresenter} from "@/utils/presenters/EditPresenter.ts";
import CustomReportLauncherAction from "@/utils/editView/editScreens/CustomReportLauncherAction.ts";
import CustomRepInfo = namaTypes.CustomRepInfo;
import ByIdRequest = namaTypes.ByIdRequest;
import ReportMetadataContainer = namaTypes.ReportMetadataContainer;

export default class CustomReportLauncherMenuItem extends MoreMenuItem
{
  presenter: WidgetsPresenter;
  customRepInfo: CustomRepInfo;

  constructor(presenter: WidgetsPresenter, customRepInfo: CustomRepInfo) {
    super();
    this.presenter = presenter;
    this.customRepInfo = customRepInfo;
  }

  override get text(): string | undefined {
    return Translator.translateNaMaText(this.customRepInfo.title, this.presenter.entityType);
  }

  override get id(): string | undefined {
    return this.customRepInfo.reportId;
  }

  override get executeFn(): Function | undefined {
    return async () => {
      let request: ByIdRequest = {
        entityType: DomainBaseEntities.ReportDefinition,
        id: this.customRepInfo.reportId
      };
      let result = await NamaCommon.namaFetch(NamaURLS.FetchReportMetadata, {
        data: request
      });
      if (!result || !NamaCommon.isSuccess(result))
        return;
      let reportMetaData: ReportMetadataContainer = result.data as ReportMetadataContainer;
      if (this.presenter instanceof ListPresenter && reportMetaData.report?.extraData &&
        ObjectChecker.isAnyEqualToFirst(reportMetaData.report?.extraData["reportType"], "UserForm", "UserList")) {
        this.presenter.printUsing(this.customRepInfo);
        return;
      }
      if (this.presenter instanceof EditPresenter) {
        let parameterValues = this.presenter.fetchDispatcher().mapParameters(this.customRepInfo);
        let questions = CustomReportLauncherAction.buildQuestions(parameterValues, this.customRepInfo);
        await CustomReportLauncherAction.launchReport(questions, reportMetaData.metadata!, this.customRepInfo);
      }
      if (this.presenter instanceof ListPresenter) {
        await CustomReportLauncherAction.handleCustomReportForListView(this.presenter, this.customRepInfo, reportMetaData);
      }
    };
  }
}
